<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="#FF1313" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <!-- <v-flex xs2>
              <v-btn color="black" dark>
                  Add
              </v-btn>
          </v-flex> -->
      <v-flex xs12>
        <v-switch
          v-model="colorStatus"
          color="#5DC57C"
          hide-details
          :ripple="false"
          class="statusKey pt-2"
        >
          <template slot="label">
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 16px;
              "
              v-text="colorStatus ? 'Yes' : 'No'"
            >
            </span>
          </template>
        </v-switch>
      </v-flex>
      <v-flex xs6 v-if="colorStatus == true">
        <v-layout wrap v-for="(item, i) in color" :key="i">
          <v-flex xs4 px-6>
            <span class="styloopinputlabel"> color </span
            ><span class="ibmregular xsmall">
              {{ item.color }}
            </span>

            <input
              style="width: 100%; height: 40px"
              type="color"
              id="newColor"
              name="newColor"
              value="#000000"
              v-model="item.color"
            />
          </v-flex>
          <v-flex xs4 pl-sm-2>
            <span class="styloopinputlabel"> Stock </span>
            <v-text-field
              v-model="item.stock"
              type="number"
              color="#FF1313"
              hide-selected
              outlined
              placeholder="Available Stock"
              dense
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs4 sm3 pt-6 pl-1>
            <v-btn
              @click.prevent="color.splice(i, 1)"
              class="mx-2"
              fab
              dark
              x-small
              color="red"
            >
              <v-icon dark> mdi-minus </v-icon>
            </v-btn>
            <!-- <v-btn fab   dark class="mx-2"
      small  tile @click.prevent="color.splice(i,1)"><v-icon dark>mdi-minus</v-icon></v-btn> -->
          </v-flex>
        </v-layout>
        <v-layout wrap py-6>
          <v-flex xs4 px-2>
            <v-btn tile color="primary" dark small block @click="addToArray()"
              >Add
            </v-btn>
          </v-flex>

          <!-- <v-flex xs4 px-2>
            <v-btn tile small block>cancel</v-btn>
          </v-flex> -->
          <v-flex xs4 px-2>
            <v-btn
              tile
              dark
              block
              small
              :color="btnColor"
              @click="backToStepper()"
              >{{ buttonName }}</v-btn
            >
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["storage", "sizeData", "isColor"],
  data() {
    return {
      showSnackBar: false,
      timeout: 5000,
      msg: "",
      buttonName: "save",
      btnColor: "red",
      totalStock: 0,
      colorStatus: false,
      newColor: null,
      newStock: null,
      moreColor: 1,
      color: [],
      colorDetails: {
        color: '#000000',
        stock: 0,
      },
      storageDetails: [],
    };
  },
  watch: {
    color() {
      this.buttonName = "save";
      this.btnColor = "red";
    },
    colorStatus() {
      if(!this.colorStatus)
      this.color = [];
      this.backToStepper();
    },
  },
  beforeMount() {
    // console.log("wht",this.isColor)
    if (this.isColor) {
      this.storageDetails = this.storage;
      this.storageDetails = this.storageDetails.map((y) => {
        y.colorSave = y.color;
        y.color = JSON.parse(y.color);
        y.colorHex = y.color.toString(16);
        y.colorHex = y.colorHex.substring(2);
        y.colorHex = "#" + y.colorHex;
        y.color = y.colorHex;
        return y;
      });

      this.color = this.storage;
      this.colorStatus = this.isColor;
      // console.log("wht",this.color)
    }
  },
  methods: {
    addToArray() {
      this.moreColor = this.moreColor + 1;
      if (document.getElementById("newColor")) {
        this.colorDetails.color = document.getElementById("newColor").value;
      }
      // this.totalStock = this.totalStock +  item;
      this.colorDetails.stock = this.newStock;
      this.color.push(JSON.parse(JSON.stringify(this.colorDetails)));
      // this.totalStock = this.totalStock +  this.colorDetails.stock
      // console.log("The array is=", this.color);
    },
    backToStepper() {
      this.msg="Color/Stock details updated successfully!"
      this.showSnackBar=true
      this.buttonName = "saved";
      this.btnColor = "green";
      this.totalStock = 0;
      // if(!this.storage) {
      //   this.color = this.color.map((y) => {
      //   y.colorSave = y.color;
      //   y.color = JSON.parse(y.color);
      //   y.colorHex = y.color.toString(16);
      //   y.colorHex = y.colorHex.substring(2);
      //   y.colorHex = "#" + y.colorHex;
      //   y.color = y.colorHex;
      //   return y;
      // });
      // }
      
      for (let i = 0; i < this.color.length; i++) {
        this.totalStock += JSON.parse(this.color[i].stock);
      }
      this.$emit("stepper", {
        productStock: this.color,
        statusValue: this.colorStatus,
        total: this.totalStock,
        haveTotal: this.colorStatus,
      });
    },
  },
};
</script>